__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "uk_borrower_platform_card";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@reduxjs/toolkit", "1.8.5", function() { return Promise.all([__webpack_require__.e(881), __webpack_require__.e(683)]).then(function() { return function() { return __webpack_require__(7881); }; }); });
			register("@tanstack/react-query", "4.2.3", function() { return Promise.all([__webpack_require__.e(408), __webpack_require__.e(416)]).then(function() { return function() { return __webpack_require__(7408); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(164), __webpack_require__.e(416)]).then(function() { return function() { return __webpack_require__(4164); }; }); });
			register("react-redux", "8.0.2", function() { return Promise.all([__webpack_require__.e(452), __webpack_require__.e(416), __webpack_require__.e(51), __webpack_require__.e(885)]).then(function() { return function() { return __webpack_require__(3452); }; }); });
			register("react-router-dom", "6.3.0", function() { return Promise.all([__webpack_require__.e(608), __webpack_require__.e(416), __webpack_require__.e(37)]).then(function() { return function() { return __webpack_require__(608); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(791).then(function() { return function() { return __webpack_require__(2791); }; }); });
			register("styled-components", "5.3.5", function() { return Promise.all([__webpack_require__.e(444), __webpack_require__.e(416)]).then(function() { return function() { return __webpack_require__(6444); }; }); });
			initExternal(9310);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};